var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9802 13.8966C15.1013 13.816 15.2407 13.7668 15.3857 13.7537C15.5306 13.7405 15.6766 13.7637 15.8103 13.8211L20.9684 16.1322C21.1423 16.2065 21.2874 16.3351 21.382 16.4988C21.4766 16.6624 21.5157 16.8523 21.4934 17.04C21.3235 18.3099 20.6982 19.4749 19.7337 20.3183C18.7692 21.1616 17.5312 21.626 16.25 21.625C12.3049 21.625 8.52139 20.0579 5.73179 17.2682C2.94219 14.4786 1.375 10.6951 1.375 6.75004C1.37402 5.46882 1.8384 4.23086 2.68177 3.26637C3.52514 2.30188 4.69011 1.67653 5.96 1.5066C6.14773 1.4843 6.33762 1.52339 6.50127 1.61803C6.66492 1.71267 6.79352 1.85777 6.86781 2.0316L9.17891 7.1941C9.23569 7.32669 9.25881 7.47127 9.24622 7.61496C9.23363 7.75865 9.18571 7.897 9.10672 8.01769L6.76938 10.7969C6.68647 10.922 6.63744 11.0665 6.62709 11.2162C6.61673 11.366 6.64541 11.5158 6.71031 11.6511C7.61485 13.5028 9.52891 15.3939 11.3861 16.2897C11.5221 16.3543 11.6727 16.3824 11.8229 16.3711C11.973 16.3597 12.1177 16.3095 12.2425 16.2252L14.9802 13.8966Z",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/phone_logo.178ea96220479768f43b966222aab4f1.svg";
export { ForwardRef as ReactComponent };